A partner-provided unique ID for the question.

This can be used to correlate the question back to its corresponding representation in your software.
